module.exports = __webpack_public_path__ + "img/9791159252877.08de3694.jpg";